/* eslint-disable camelcase */
import { GET_WORKSHOP_CONTACT } from '../constants/workshopContact';

// eslint-disable-next-line import/prefer-default-export
export const getWorkshopContact = (data) => {
  const { id, workshop_contact } = data;
  const { contact_phone, contact_phone2, contact_email, contact_email2 } = workshop_contact;
  return (dispatch) => {
    dispatch({
      type: GET_WORKSHOP_CONTACT,
      workshopOwnershipId: id,
      contactPhone: contact_phone,
      contactPhone2: contact_phone2,
      contactEmail: contact_email,
      contactEmail2: contact_email2,
    });
  };
};
